exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-anim-svg-_jUXY{background:hsla(0,0%,100%,0);visibility:hidden}", ""]);

// Exports
exports.locals = {
	"anim-svg": "index-anim-svg-_jUXY"
};